<svg:g
  *ngFor="let subpointInfo of allSubpointInfo$ | async; trackBy: trackByIndex"
  [h3Subpoint]="subpointInfo"
  [shapeSelected]="selected"
  (mousedown)="handleMouseEvent($event, 'subpoint', subpointInfo.subpointIndex)"
  (dblclick)="handleMouseEvent($event, 'shape')"
  (mouseup)="handleMouseEvent($event, 'shape')"
/>
